import { ChangeDetectorRef, Component, Input, LOCALE_ID, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SortEvent } from 'primeng/api';
import { ConsultaEstoqueService } from '../veiculo-estoque-service/veiculo-estoque.service';
import { ConversaoLibraConverte } from '../../../../shared/conversao-libra/conversao-libra-converte';
import { Filtros } from '../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from '../../../../shared/crud/ListaBase';
import { ExportExcelService } from '../../../../shared/excel-service/export-excel.service';

@Component({
  selector: 'app-veiculo-estoque-lista',
  templateUrl: './veiculo-estoque-lista.component.html',
  styleUrls: ['./veiculo-estoque-lista.component.css'],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    }
  ]
})
export class ConsultaEstoqueListaComponent extends ListaBase implements OnInit {
  first = 0;
  rows = 10;
  filtros: any = {};
  dealersDados = [];
  cols: any[];
  _selectedColumns: any[];
  loading = true;
  subscription;
  @Input() datas: any;

  constructor(service: ConsultaEstoqueService,
    toastr: ToastrService,
    router: Router,
    private excelExport: ExportExcelService,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toastr, router);
    this.filtros = {};
    this.nomeModulo = 'veiculo-estoque';
  }

  @Input() set carregar(valores: any[]) {
    if (valores.length > 0) {

      this.limparFiltros();
      valores.forEach(item => {
        new FiltroDealer(new FiltroEspecifico(null))
          .gerar(item, this.filtros);
      });
    } else {
      this.limparFiltros();
    }
    this.buscar();
  }

  dadosTranslate = {
    "Dealer": "relatorioVeiculos.veiculoEstoque.dealer",
    "Chassi": "relatorioVeiculos.veiculoEstoque.chassi",
    "Marca": "relatorioVeiculos.veiculoEstoque.marca",
    "Modelo": "relatorioVeiculos.veiculoEstoque.modelo",
    "Valor de Venda": "relatorioVeiculos.veiculoEstoque.valorVenda",
    "Cor Externa": "relatorioVeiculos.veiculoEstoque.corExterna",
    "Acabamento Interno": "relatorioVeiculos.veiculoEstoque.corInterna",
    "Ano/Modelo": "relatorioVeiculos.veiculoEstoque.anoModelo",
    "Tipo": "relatorioVeiculos.veiculoEstoque.tipo",
    "Status": "relatorioVeiculos.veiculoEstoque.status",
    "Proposta": "relatorioVeiculos.veiculoEstoque.proposta",
    "Dias Em Estoque": "relatorioVeiculos.veiculoEstoque.diasEstoque",
    "Data da Compra": "relatorioVeiculos.veiculoEstoque.dataCompra",
  }


  limparFiltros(): any {
    this.filtros.dealers = '';
    this.filtros.grupo_economico = '';
    this.filtros.chassi = '';
    this.filtros.situacao = '';
    this.filtros.marca = '';
    this.filtros.placa = '';
    this.filtros.status = '';
    this.filtros.exibirTransf = '';
    this.filtros.PATIO = '';
  }

  buscar() {
    let objFiltro: Filtros = new Filtros();

    this.filtros.tipo = this.datas.tipo_data;
    this.filtros.data_inicial = this.formatDateTime(this.datas.data_inicial);
    this.filtros.data_final = this.formatDateTime(this.datas.data_final);

    if (this.filtros.exibirTransf == 'true') {
      this.filtros.exibirTransf = "true";
    } else {
      this.filtros.exibirTransf = "false";
    }

    if (this.filtros.status == 'T') {
      this.filtros.exibirTransf = "true";
    }

    // Pátio: Estoque -> L, Trânsito -> T, Exposição -> E.
    // Essas opções enviam apenas o filtro 'PATIO', sem o 'status'.
    this.filtros.PATIO = '';
    let statusEhPatio = false;
    if (this.filtros.status == 'N') {
      this.filtros.PATIO = 'L';
      statusEhPatio = true;
    } else if (this.filtros.status == 'TRANSITO') {
      this.filtros.PATIO = 'T';
      statusEhPatio = true;
    } else if (this.filtros.status == 'EXPOSICAO') {
      this.filtros.PATIO = 'E';
      statusEhPatio = true;
    }

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        if (chave === 'status' && statusEhPatio) {
          continue;
        }
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.loading = true;

    this.service.buscar(objFiltro)
      .then(res => {
        this.dealersDados = res.dealers;

        this.dealersDados.forEach(element => {
          const atual = this.conversaoLibraConverte.conversaoLibra(element.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(atual);
          element.valorVenda = valorFormatado.replace("R$", "");

          if (element.dtUltimaAtual == null) {
            element.dtUltimaAtual = '';
            element.dtUltimaAtualFormatted = '';
          } else {
            element.dtUltimaAtualOriginal = element.dtUltimaAtual;
            element.dtUltimaAtualFormatted = this.formatDateTime(new Date(element.dtUltimaAtual));
            element.dtUltimaAtual = element.dtUltimaAtual;
          }

          if (element.data_compra != null) {
            element.data_compra = this.formatDateOnly(element.data_compra);
          }
        });
        this.loading = false;
      })
  }

  ngOnInit() {
    this.cols = [
      { field: 'nome', header: 'relatorioVeiculos.veiculoEstoque.dealer', headerBr: 'Dealer', headerGb: 'Dealer', width: '300px' },
      { field: 'chassi', header: 'relatorioVeiculos.veiculoEstoque.chassi', headerBr: 'Chassi', headerGb: 'Chassis', width: '250px' },
      { field: 'marca', header: 'relatorioVeiculos.veiculoEstoque.marca', headerBr: 'Marca', headerGb: 'Brand', width: '120px' },
      { field: 'modelo', header: 'relatorioVeiculos.veiculoEstoque.modelo', headerBr: 'Modelo', headerGb: 'Model', width: '350px' },
      { field: 'valorVenda', header: 'relatorioVeiculos.veiculoEstoque.valorVenda', headerBr: 'Valor de venda', headerGb: 'Sale Value', width: '120px' },
      { field: 'corExterna', header: 'relatorioVeiculos.veiculoEstoque.corExterna', headerBr: 'Cor Externa', headerGb: 'External Color', width: '240px' },
      { field: 'corInterna', header: 'relatorioVeiculos.veiculoEstoque.corInterna', headerBr: 'Cor Interna', headerGb: 'Internal Color', width: '240px' },
      { field: 'anoModelo', header: 'relatorioVeiculos.veiculoEstoque.anoModelo', headerBr: 'Ano/Modelo', headerGb: 'Year/Model', width: '120px' },
      { field: 'situacao', header: 'relatorioVeiculos.veiculoEstoque.tipo', headerBr: 'Tipo', headerGb: 'Type', width: '120px' },
      { field: 'status', header: 'relatorioVeiculos.veiculoEstoque.status', headerBr: 'Status', headerGb: 'Status', width: '120px' },
      { field: 'proposta', header: 'relatorioVeiculos.veiculoEstoque.proposta', headerBr: 'Proposta', headerGb: 'Proposal', width: '100px' },
      { field: 'tempoEstoque', header: 'relatorioVeiculos.veiculoEstoque.diasEstoque', headerBr: 'Dias Em Estoque', headerGb: 'Days In Stock', width: '200px' },
      { field: 'dtUltimaAtual', header: 'relatorioVeiculos.veiculoEstoque.dtUltimaAtual', headerBr: 'Data Última Atualização', headerGb: 'Last Updated Date', width: '200px' },
      { field: 'data_compra', header: 'relatorioVeiculos.veiculoEstoque.dataCompra', headerBr: 'Data da Compra', headerGb: 'Purchase Date', width: '200px' },
    ];

    this._selectedColumns = this.cols;

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.buscar();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.grupo_economico
      || this.filtros.chassi
      || this.filtros.situacao
      || this.filtros.marca
      || this.filtros.placa
      || this.filtros.status
      || this.filtros.exibirTransf
      || this.filtros.dataInicio
      || this.filtros.dataFim
      || this.filtros.tipoData;
  }

  exportarExcel() {
    this.excelExport.nomeModulo = this.nomeModulo;
    this.excelExport.ExportTOExcelJSON(this.dealersDados.map(r => {
      let linha = {};

      this._selectedColumns.forEach(c => {
        linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
      });

      return linha;
    }));
  }

  translateHeader(item) {
    if (item == "relatorioVeiculos.veiculoEstoque.dealer") {
      return "Dealer";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.status") {
      return "Status";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.chassi") {
      return this.translate.currentLang == "br" ? "Chassi" : "Chassis";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.marca") {
      return this.translate.currentLang == "br" ? "Marca" : "Brand";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.modelo") {
      return this.translate.currentLang == "br" ? "Modelo" : "Model";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.valorVenda") {
      return this.translate.currentLang == "br" ? "Valor de Venda" : "Sale Value";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.corExterna") {
      return this.translate.currentLang == "br" ? "Cor Externa" : "External Color";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.corInterna") {
      return this.translate.currentLang == "br" ? "Acabamento interno" : "Internal Color";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.anoModelo") {
      return this.translate.currentLang == "br" ? "Ano/Modelo" : "Year/Model";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.tipo") {
      return this.translate.currentLang == "br" ? "Tipo" : "Type";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.proposta") {
      return this.translate.currentLang == "br" ? "Proposta" : "Proposal";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.diasEstoque") {
      return this.translate.currentLang == "br" ? "Dias Em Estoque" : "Days In Stock";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.dtUltimaAtual") {
      return this.translate.currentLang == "br" ? "Data Última Atualização" : "Last Updated Date";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.dataCompra") {
      return this.translate.currentLang == "br" ? "Data da Compra" : "Purchase Date";
    }
  }

  translateField(item) {
    if (item == "relatorioVeiculos.veiculoEstoque.statusGrid.estoque" || item == "Estoque") {
      return this.translate.currentLang == "br" ? "Estoque" : "Stock";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.statusGrid.bloqueado" || item == "Bloqueado") {
      return this.translate.currentLang == "br" ? "Bloqueado" : "Blocked";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.statusGrid.reservado" || item == "Reservado") {
      return this.translate.currentLang == "br" ? "Reservado" : "Reserved";
    }
    if (item == "relatorioVeiculos.veiculoEstoque.statusGrid.transferencia" || item == "Transferido") {
      return this.translate.currentLang == "br" ? "Transferido" : "Transferred";
    }

    return item;
  }

  getTranslate(value) {
    if (value.status === 'Estoque') {
      return value.status = 'relatorioVeiculos.veiculoEstoque.statusGrid.estoque';
    }

    if (value.status === 'Reservado') {
      return value.status = 'relatorioVeiculos.veiculoEstoque.statusGrid.reservado';
    }

    if (value.status === 'Bloqueado') {
      return value.status = 'relatorioVeiculos.veiculoEstoque.statusGrid.bloqueado';
    }

    if (value.status === 'Transferido') {
      return value.status = 'relatorioVeiculos.veiculoEstoque.statusGrid.transferencia';
    }

    return this.dadosTranslate[value];
  }

  carregarFiltroVazio() {
    this.filtros.grupo_economico = null
    this.filtros.chassi = null
    this.filtros.situacao = null
    this.filtros.marca = null
    this.filtros.placa = null
    this.filtros.status = null
    this.filtros.exibirTransf = null
  }

  formatDateTime(value: any): string {
    let pad: Function = (val: number) => {
      return val < 10 ? '0' + val : val;
    };
    return pad(value.getDate()) + '/' + pad(value.getMonth() + 1) + '/' + value.getFullYear()
      + ' ' + pad(value.getHours()) + ':' + pad(value.getMinutes()) + ':' + pad(value.getSeconds());
  }

  formatDateOnly(value: any): string {
    if (!value) {
      return '';
    }
    if (typeof value === 'string' && value.length >= 10) {
      const [ano, mes, dia] = value.substring(0, 10).split('-');
      return `${dia}/${mes}/${ano}`;
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) {
      return value;
    }
    const pad = (val: number) => val < 10 ? '0' + val : '' + val;
    return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear();
  }

  // Ordenação
  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;
      else if (event.field === 'dtUltimaAtual') {
        result = this.compareISODates(value1, value2);
        console.log('Comparando datas ISO:', value1, 'vs', value2, 'resultado:', result);
      }
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      const finalResult = (event.order * result);
      console.log('Resultado final:', finalResult);
      return finalResult;
    });
  }

  /**
   * Compara duas datas no formato ISO (YYYY-MM-DDTHH:mm:ss)
   * Retorna: -1 se date1 < date2, 0 se iguais, 1 se date1 > date2
   */
  private compareISODates(isoDate1: string, isoDate2: string): number {
    try {
      console.log('Comparando datas ISO:', isoDate1, 'vs', isoDate2);
      
      // Se alguma das datas estiver vazia, tratar como menor
      if (!isoDate1 || isoDate1.trim() === '') {
        console.log('Data1 vazia, retornando -1');
        return -1;
      }
      if (!isoDate2 || isoDate2.trim() === '') {
        console.log('Data2 vazia, retornando 1');
        return 1;
      }
      if (!isoDate1 && !isoDate2) {
        console.log('Ambas datas vazias, retornando 0');
        return 0;
      }

      // Converter strings ISO para objetos Date
      const date1 = new Date(isoDate1);
      const date2 = new Date(isoDate2);

      console.log('Datas convertidas:', date1, 'vs', date2);

      // Verificar se as datas são válidas
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        console.log('Data inválida, usando fallback string');
        return isoDate1.localeCompare(isoDate2);
      }

      // Comparar os timestamps
      const time1 = date1.getTime();
      const time2 = date2.getTime();

      console.log('Timestamps:', time1, 'vs', time2);

      if (time1 < time2) return -1;
      if (time1 > time2) return 1;
      return 0;

    } catch (error) {
      console.warn('Erro ao comparar datas ISO:', error);
      // Fallback para comparação de string
      return isoDate1.localeCompare(isoDate2);
    }
  }


  // Paginação
  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.service ? this.first === (this.service.length - this.rows) : true;
  }

  isFirstPage(): boolean {
    return this.service ? this.first === 0 : true;
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
}

abstract class GerarFiltro {

  proximoGerador: GerarFiltro;

  constructor(proximoGerador: GerarFiltro) {
    this.proximoGerador = proximoGerador;
  }

  public abstract gerar(item: any, filtros: any);

}

class FiltroDealer extends GerarFiltro {

  public gerar(item: any, filtros: any) {
    if (item.chave === 'dealers') {
      const itens: string[] = [];
      item.valor.forEach(element => {
        itens.push(element);
      });
      filtros.dealers = itens;
    } else {
      this.proximoGerador.gerar(item, filtros);
    }
  }
}

class FiltroEspecifico extends GerarFiltro {

  public gerar(item: any, filtros: any) {
    filtros[item.chave] = item.valor;
  }
}
